export default (to, from, next) => {
	next()
}



// WEBPACK FOOTER //
// ./src/router/middleware/all.js